/**
 * Delete organization button.
 *
 * @author Ryan Johnston <ryan.johnston@scalesology.com>
 */
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import Button from 'js/Components/Forms/Raw/Button';
import ConfirmModal from 'js/Components/Modal/Raw/ConfirmModal';
import noop from 'js/noop';
import organizationPropType from 'js/PropTypes/organization';
import UserContext from 'js/Context/UserContext';

/**
 * Delete organization button class.
 */
class DeleteOrganizationButton extends Component {
    static propTypes = {
        onDeleteOrganization: PropTypes.func,
        organization: organizationPropType,
    };

    static defaultProps = {
        onDeleteOrganization: noop,
        organization: {},
    };

    /**
     * constructor
     *
     * @param {object} props Properties
     *
     * @returns {void}
     */
     constructor(props) {
        super(props);

        this.state = {
            confirmOpen: false,
        };

        // Efficient early binding.
        this.onCloseConfirm = this.onCloseConfirm.bind(this);
        this.onConfirmDelete = this.onConfirmDelete.bind(this);
        this.onShowConfirm = this.onShowConfirm.bind(this);
    }

    /**
     * Event handler for confirmation modal close.
     *
     * @returns {void}
     */
     onCloseConfirm() {
        this.setState({
            confirmOpen: false,
        });
    }

    /**
     * Event handler for delete after confirmation modal.
     *
     * @returns {void}
     */
    onConfirmDelete() {
        const { onDeleteOrganization, organization } = this.props;

        if (onDeleteOrganization) {
            onDeleteOrganization(organization.id);
        }

        this.onCloseConfirm();
    }

    /**
     * Event handler for confirmation modal show.
     *
     * @returns {void}
     */
    onShowConfirm() {
        this.setState({
            confirmOpen: true,
        });
    }

    /**
     * Render Delete organization button.
     *
     * @returns {React.node}
     */
    render() {
        const { organization } = this.props;
        const { confirmOpen } = this.state;
        const organizationName = organization.name ? organization.name : 'this organization';

        return (
            <>
                <UserContext.Consumer>
                    {({ hasPermission, personSession }) => {
                        const isSignInUserOrg = personSession.person.organization.id === organization.id;

                        if (hasPermission('manage.organizations')) {
                            return (
                                <Button
                                    disabled={isSignInUserOrg}
                                    onClick={this.onShowConfirm}
                                    title={isSignInUserOrg ? 'You can not delete your own organization.' : null}
                                >
                                    Delete
                                </Button>
                            );
                        }

                        return null;
                    }}
                </UserContext.Consumer>
                <ConfirmModal
                    message={`Are you sure you want to delete ${organizationName}?`}
                    open={confirmOpen}
                    onClose={this.onCloseConfirm}
                    onConfirm={this.onConfirmDelete}
                />
            </>
        );
    }
}

export default DeleteOrganizationButton;
